<template>
  <div class="content-wapper">
    <el-row class="navigation">
      <el-col align="left">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '' }">知识产权综合服务</el-breadcrumb-item>
          <el-breadcrumb-item>知识产权转移转化</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <el-row>
          <el-col>
            <div class="" style="margin-bottom: 10px">
              <img src="../../../../assets/images/main/new/zscqzyzh/zscqzyzh.png" style="" />
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div class="whptClass"  >
              <img src="../../../../assets/images/main/new/zscqzyzh/whptback.png" style="" @click="openOutPage('https://cponline.cnipa.gov.cn/')"/>
<!--              <div class="whptRegisterClass"  @click="openOutPage('https://cponline.cnipa.gov.cn/')">-->
<!--                <img src="../../../../assets/images/main/new/zscqzyzh/whptRegister.png" style="" />-->
<!--              </div>-->
<!--              <div class="whptLoginClass"  @click="openOutPage('https://cponline.cnipa.gov.cn/')">-->
<!--                <img src="../../../../assets/images/main/new/zscqzyzh/whptLogin.png" style="" />-->
<!--              </div>-->
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div class="zlcs"  @click="openPage('/main/zscqzhfw/zscqcs')">
              <img src="../../../../assets/images/main/new/zscqzyzh/zlcsback.png" style="" />
              <div class="zlcsIcon">
                <img src="../../../../assets/images/main/new/zscqzyzh/zlcsIcon.png" style="" />
              </div>
              <div class="zlcsImage">
                <img src="../../../../assets/images/main/new/zscqzyzh/zlcs.png" style="" />
              </div>
<!--              <div class="zlcsFont">-->
<!--                <span>更多 ></span>-->
<!--              </div>-->
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="18" >
        <div class="introduceMainClass">
          <div class="introduceTop">
            <img class="mainImage" src="../../../../assets/images/main/new/zscqzyzh/introduction.png" />
            <span style="position: absolute;top: 32px;left: 64px;font-size: 20px;color: #383838">平台简介</span>
          </div>
          <el-divider style="width: 80%!important;"></el-divider>
          <div class="introduceContent">
            <p>
              专利开放许可声明、专利实施许可备案。当事人选择电子形式在线提交，可以通过专利业务办理系统的专利事务服务——专利合同审查<br>——专利开放许可声明/专利实施许可备案模块在线提交。
            </p>
          </div>
          <div>
            <el-button type="primary" class="button" @click="openOutPage('https://cponline.cnipa.gov.cn/')">在线办理</el-button>
            <img class="iconClass" src="../../../../assets/images/main/new/zscqzyzh/icon.png" />
          </div>
        </div>

      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name:"zscqzyzh",
  methods:{
    openOutPage(url){
      this.utils.windowOpen(url);
    },
    openPage(url) {

      this.$router.push({ path: url })
    },
  }
}
</script>

<style scoped>
.content-wapper{
  margin-top: 5px;
  padding: 10px;
}
.navigation{
  padding:20px 15px;
  line-height: 20px;
  height: 60px;
  background-color: #F5F5F5;
  margin-bottom: 15px;
}

.whptClass {
  margin-bottom: 10px;
  position: relative;
  top: 0;
  left: 0;
  cursor: pointer;
}
.whptRegisterClass {
  position: absolute;
  top: 145px;
  left: 8px;
  cursor: pointer;
}
.whptLoginClass {
  position: absolute;
  top: 145px;
  left: 167px;
  cursor: pointer;
}
.zlcs{
  position: relative;
  top: 0;
  left: 0;
  cursor: pointer;
}
.zlcsIcon{
  position: absolute;
  top: 25px;
  left: 30px;
}
.zlcsImage{
  position: absolute;
  top: 30px;
  left: 80px;
}
.zlcsFont{
  position: absolute;
  top: 55px;
  left: 250px;
  font-size: 15px;
  color: #000000;
}
.introduceMainClass{
  background-color: #f5f5f5;
  margin-left: 15px;
  height: 289px;
}
.introduceTop{
  position: relative;
  top: 0;
  left: 0;
  height: 87px;
}
.mainImage{
  position: absolute;
  top: 32px;
  left: 20px
}
::v-deep .el-divider--horizontal{
  margin-left: 20px;
  margin-right: 20px;
  width: 95%;
  color: #cacaca;
}
.introduceContent{
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
  font-size: 15px;
  line-height : 40px;
  text-align: left;
  text-indent: 2em;
  color: #000000;

}

.button{
  width: 175px;
  height: 36px;
  font-size: 15px;
  color: #ffffff;
  border-radius:17.5px;
  position: absolute;
  right: 30px;
}

.iconClass{
  position: absolute;
  top: 239px;
  right: 60px;
  line-height: 40px;
}

</style>
